// src/common/components/Input/Input.tsx
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import { ValidationResultInterface } from "../../types/types";
import styles from "./Input.module.scss";

type Props = {
  type?: string;
  value: string | number;
  placeholder?: string;
  onChange: (value: string) => void;
  fieldName: string;
  validationResult?: ValidationResultInterface;
  onBlur?: (fieldName: string) => void;
  label?: string;
  multiline?: boolean;
  rows?: number;
};

export const Input = ({
  type = "text",
  value,
  placeholder,
  onChange,
  fieldName,
  validationResult,
  onBlur,
  label,
  multiline = false,
  rows = 1,
}: Props) => {
  const { isDark } = useTheme();

  const getInputClassName = () => {
    if (validationResult?.isEmptyError && isDark) return styles.requiredDark;
    if (validationResult?.isEmptyError) return styles.required;
    if (isDark) return styles.dark;
    return styles.normal;
  };

  const inputProps = {
    className: getInputClassName(),
    placeholder,
    value,
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange(e.target.value),
    onBlur: () => onBlur && onBlur(fieldName),
  };

  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}

      {multiline ? (
        <textarea {...inputProps} rows={rows} />
      ) : (
        <input type={type} {...inputProps} />
      )}

      <div className={styles.validationError}>
        {validationResult?.isDirty &&
          validationResult?.notValid &&
          validationResult?.errorMessage}
      </div>
    </div>
  );
};
